import React from 'react'

const Text = (({text,classNames})=>(
	<div className={classNames && classNames ? classNames :"text"} dangerouslySetInnerHTML={{__html: text}} />
))

export default Text


// WEBPACK FOOTER //
// ./src/Components/Text/index.js